import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import SelectFieldPeriodosAcademicosComponent from '../../../control_estudios/periodos_academicos/components/SelectFieldPeriodosAcademicos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveEntAjustesAction } from '../EntAjustesAction';

const FormEntAjustes = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const activo = entidadesStore.ajustes;

  const initData = {
    generarFacturas: false,
    cantidadFacturas: 2,
    idioma: 'ES',
    tipoAsistencia: 'DIA',
    minutosAcademicos: 45,
    competencia: 20,
    ponderacion: 20,
    mesesMorosidad: 1,
    bloquesPedagogicos: 3,
    idPeriodoAcademico: null,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({});
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idPeriodoAcademico: activo?.periodoAcademico?.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (await _validDataForm()) {
      setLoadingSave(true);
      await saveEntAjustesAction(
        { dispatch, notify },
        {
          idEntidad: entidadesStore.activo.id,
          ...data,
        },
      );
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        </Grid>

        <Grid item xs={12} md={12}>
          <SelectFieldPeriodosAcademicosComponent
            value={data.idPeriodoAcademico ?? ''}
            onChange={(id) =>
              _handleSetDataField(CONST.periodoAcademico.idName, id)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.ponderacion.name}
            required
            label={CONST.ponderacion.ajustes}
            value={data.ponderacion}
            type="number"
            inputProps={{
              min: 1,
              max: 100,
            }}
            onChange={(e) =>
              _handleSetDataField(CONST.ponderacion.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.competencia.name}
            required
            label={CONST.competencia.ajustes}
            type="number"
            inputProps={{
              min: 1,
              max: 100,
            }}
            value={data.competencia}
            onChange={(e) =>
              _handleSetDataField(CONST.competencia.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.mesesMorosidad.name}
            required
            label={CONST.mesesMorosidad.ajustes}
            value={data.mesesMorosidad}
            type="number"
            inputProps={{
              min: 1,
              max: 12,
            }}
            onChange={(e) =>
              _handleSetDataField(CONST.mesesMorosidad.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.minutosAcademicos.name}
            required
            label={CONST.minutosAcademicos.ajustes}
            type="number"
            inputProps={{
              min: 1,
              max: 60,
            }}
            value={data.minutosAcademicos}
            onChange={(e) =>
              _handleSetDataField(CONST.minutosAcademicos.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.bloquesPedagogicos.name}
            required
            label={CONST.bloquesPedagogicos.ajustes}
            type="number"
            inputProps={{
              min: 1,
              max: 12,
            }}
            value={data.bloquesPedagogicos}
            onChange={(e) =>
              _handleSetDataField(CONST.bloquesPedagogicos.name, e.target.value)
            }
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            loading={loadingSave}
            click={_handleSubmit}
            save
            disabled={loadingSave}
            green
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntAjustes;
